import i18n from "utils/i18n";
import { RepositoryFactory } from "repositories/factory";
import { Validator, ERROR_TYPE_CD } from "./validator";

const NotificationRecipientsRepository = RepositoryFactory.get("notification-recipients");

const ITEM_CODE = {
  EMAIL: "01",
};

class NotificationRecipientsValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
    this.errors.password = [];
  }

  async checkEmail(key, val, serviceAccountId, attributeName, itemCd) {
    const checkVal = val || "";

    // 必須チェック
    if (Validator.isEmpty(checkVal)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // 書式チェック
    if (!Validator.isEmail(checkVal)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.email.format", { attribute: attributeName }),
      );
    }

    // 入力フォーマットが有効であれば、プロダクトキーのチェックを行う
    if (this.getErrorMsg("email") === "") {
      // 利用可能な監視デバイス
      let registerd = false;
      const notification_recipients
        = await NotificationRecipientsRepository.index(serviceAccountId);
      for (let i = 0; i < notification_recipients.length; i += 1) {
        if (notification_recipients[i].email === val) {
          registerd = true;
          break;
        }
      }
      if (registerd) {
        this.pushValidationResultItem(
          key,
          this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
          "送信先メールアドレスは登録済みです",
        );
      }
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }
  /* eslint-enable */
}

class NotificationRecipientsStoreValidator extends NotificationRecipientsValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static async validate(email, serviceAccountId) {
    const validator = new NotificationRecipientsStoreValidator();

    // メールアドレス
    await validator.checkEmail(
      "email",
      email,
      serviceAccountId,
      "送信先メールアドレス",
      ITEM_CODE.EMAIL,
    );

    return validator;
  }
}

export {
  NotificationRecipientsStoreValidator,
};
